import { EntriesPerPageActionTypes } from '../types';
import { CHANGE_ENTRIES_PER_PAGE } from '../constants/actionTypes';

export const changeEntriesPerPage = (currentEntriesPerPage: number): EntriesPerPageActionTypes => ({
  type: CHANGE_ENTRIES_PER_PAGE,
  payload: currentEntriesPerPage,
});
